import { getTeam } from './useTeams'
import { useApiGetSport } from 'core/api/sport/useApiGetSport'
import { useApiGetTeams } from '../api/team/useApiGetTeams'

/**
 * Fetch detailed information for a list of sports.
 */
const useSportsById = (sportIds: number[] | null) => {
  return useApiGetSport({ ids: sportIds }, { enabled: sportIds?.length > 0, gcTime: Infinity })
}

/**
 * Fetch detailed information for sports a team is made of.
 */
export const useSportsForTeam = (storeId: number, teamId: number) => {
  const { data: dataTeams, isLoading: isLoadingTeams } = useApiGetTeams({
    storeId
  })
  const team = getTeam(dataTeams, teamId)
  const sportIds = team?.composition
  const sportsResult = useSportsById(sportIds)
  return { ...sportsResult, isLoading: isLoadingTeams || sportsResult.isLoading }
}

/**
 * Fetch detailed information for all sports of a given store.
 */
export const useSportsForStore = (storeId: number) => {
  return useApiGetSport({ storeId }, { enabled: !!storeId })
}
